import React from "react";
import { injectIntl } from "react-intl";
import { connect, useDispatch, useSelector } from "react-redux";
import { reduxForm } from "redux-form";
import { compose, shallowEqual } from "recompose";
import Grid from "@material-ui/core/Grid";
import { Typography, useTheme } from "@material-ui/core";
import { email, required } from "../../utilities/validators";
import { isSavingSelector } from "../../redux/selectors";
import FormTextField from "../../components/FormTextField";
import CalmButton from "../../components/CalmButton";
import { sendTemplateEmail, startSaving } from "../../redux/actions";

const SendTestEmailModal = ({
  intl,
  handleSubmit,
  languageId,
  type,
  versionId,
  surveyInstanceId,
  circleId,
  sendEmail,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSaving = useSelector(isSavingSelector, shallowEqual);

  const onSubmitForm = (values) => {
    dispatch(startSaving());
    sendEmail(
      versionId,
      surveyInstanceId,
      circleId,
      languageId,
      type,
      values.email,
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction="column" className="admin-modal">
        <Grid item style={{ width: "100%", textAlign: "center" }}>
          <Typography
            variant="h1"
            style={{ color: "white", paddingBottom: "32px" }}
          >
            {intl.formatMessage({ id: "app.template.sendEmailHeader" })}
          </Typography>
        </Grid>

        <Grid item style={{ width: "100%" }}>
          <FormTextField
            label={intl.formatMessage({ id: "app.general.email" }) + "*"}
            fullWidth
            type="text"
            name="email"
            margin="normal"
            variant="filled"
            validators={[required, email]}
          />
        </Grid>
        <Grid
          item
          style={{
            width: "100%",
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          <CalmButton
            variant="contained"
            color="primary"
            style={{
              width: "200px",
            }}
            type="submit"
            size="large"
            disabled={isSaving}
          >
            {intl.formatMessage({ id: "app.template.sendEmailSubmitButton" })}
          </CalmButton>
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  sendEmail: (
    versionId,
    surveyInstanceId,
    circleId,
    languageId,
    type,
    email,
  ) => {
    dispatch(
      sendTemplateEmail(
        versionId,
        surveyInstanceId,
        circleId,
        languageId,
        type,
        email,
      ),
    );
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: "sendTestEmail",
  }),
  injectIntl,
);

export default enhance(SendTestEmailModal);
